import { render } from "./BottomContent.vue?vue&type=template&id=3dcba2ea"
import script from "./BottomContent.vue?vue&type=script&lang=js"
export * from "./BottomContent.vue?vue&type=script&lang=js"
script.render = render

export default script